import Resource from "terriajs-cesium/Source/Core/Resource";
async function loadText(urlOrResource) {
  const resource = Resource.createIfNeeded(urlOrResource);
  const response = resource.fetchText();
  if (response === undefined) {
    throw new Error("Request throttled");
  }
  return response;
}
export default loadText;